import { render, staticRenderFns } from "./Wheel.vue?vue&type=template&id=8aa0186c&"
import script from "./Wheel.vue?vue&type=script&lang=js&"
export * from "./Wheel.vue?vue&type=script&lang=js&"
import style0 from "./Wheel.vue?vue&type=style&index=0&id=8aa0186c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports